import { fetchApi } from '@/config/axiosSetting';
import { DeleteCroquisSketchQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteCroquisSketch/deleteCroquisSketchQuery.type';

export const deleteCroquisSketchFunction = (
  params: DeleteCroquisSketchQueryParamsType,
): Promise<{}> => {
  return fetchApi({
    method: 'DELETE',
    url: `property/reports/${params.id}/accident_users/culprit/images/croquis_image/`,
  });
};
